import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

const DEFAULT_OG_IMAGE = "/cts-logo-full.png";

export default function Seo({ title, siteName, description, image, jsonLd, canonical, noindex }) {
  useEffect(() => {
    const url = canonical || window.location.origin + window.location.pathname;
    upsertLink("canonical", url);
    upsertMeta("property", "og:url", url);
    if (title) {
      document.title = title;
      upsertMeta("property", "og:title", title);
      upsertMeta("name", "twitter:title", title);
    }
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
    if (siteName) upsertMeta("property", "og:site_name", siteName);
    upsertMeta("property", "og:type", "website");
    upsertMeta("name", "twitter:card", "summary_large_image");
    const imageSrc = image || DEFAULT_OG_IMAGE;
    const abs = imageSrc.startsWith("http") ? imageSrc : window.location.origin + imageSrc;
    upsertMeta("property", "og:image", abs);
    upsertMeta("name", "twitter:image", abs);

    const robotsEl = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      upsertMeta("name", "robots", "noindex, nofollow");
    } else if (robotsEl) {
      robotsEl.remove();
    }

    const jsonLdList = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : jsonLd ? [jsonLd] : [];
    const scripts = jsonLdList.map((obj) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.seoJsonld = "true";
      script.text = JSON.stringify(obj);
      document.head.appendChild(script);
      return script;
    });
    return () => {
      scripts.forEach((s) => s.remove());
    };
  }, [title, siteName, description, image, jsonLd, canonical, noindex]);
  return null;
}
